<template>
  <div ref="layout" class="page-query">
    <TableQuery title="合同批导" :tools="false">
      <el-form inline class="form" size="mini" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item class="widget-view" label="导入类型" label-width="80">
              <el-select
                v-model="conditions.templateCode"
                placeholder="请选择"
                type="select"
                @change="conditionChanged"
              >
                <el-option
                  v-for="item in selectTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16" class="download">
            <el-dropdown @command="downloadTemplate">
              <div class="tempDownload">
                <img src="@/assets/images/excel@3x.png" alt="">
                <span class="el-dropdown-link">
                  模版下载
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{ type: 'contractBase', filename: '合同基本信息模板' }"
                >合同基本信息模板下载</el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'contractArea', filename: '合同区域信息模板' }"
                >合同区域信息模板下载</el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'contractChannel', filename: '合同渠道信息模板' }"
                >合同渠道信息下载</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <div v-loading="loading" class="table-container">
      <template v-if="conditions.templateCode === 'contractBase'">
        <TableCommon title="合同基本信息" :custome-config="() => vxeShowCustom('xTable')">
          <template #button>
            <table-button
              v-for="btn in gridOptions.buttons"
              :key="btn.label"
              :name="btn.icon"
              :tip="btn.label"
              @click="tableEvent(btn, 'xTable')"
            />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          />
        </TableCommon>
        <TableCommon title="销售产品行项目" :custome-config="() => vxeShowCustom('xTable2')">
          <vxe-grid
            ref="xTable2"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :edit-rules="{}"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptionsm.columns"
            :data="gridOptionsm.data"
          >
            <template #CHFL="{ row }">
              <span>{{ filterChfl(row.CHFL) }}</span>
            </template>
            <template #QUANTITY="{ row }">
              <el-input v-model="row.QUANTITY" size="mini" placeholder="请输入数量" />
            </template>
            <template #AMOUNT="{ row }">
              <el-input v-model="row.AMOUNT" size="mini" placeholder="请输入金额" />
            </template>
            <template #QUANTITY_OUTER="{ row }">
              <el-input v-model="row.QUANTITY_OUTER" size="mini" placeholder="请输入数量" />
            </template>
            <template #AMOUNT_OUTER="{ row }">
              <el-input v-model="row.AMOUNT_OUTER" size="mini" placeholder="请输入金额" />
            </template>
            <template #REMARK="{ row }">
              <el-input v-model="row.REMARK" size="mini" placeholder="备注" />
            </template>
          </vxe-grid>
        </TableCommon>
      </template>
      <template v-if="conditions.templateCode === 'contractArea'">
        <TableCommon
          title="合同区域信息"
          :custome-config="() => vxeShowCustom('xTable2')"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
        >
          <template #button>
            <table-button
              v-for="btn in gridOptions1.buttons"
              :key="btn.label"
              :name="btn.icon"
              :tip="btn.label"
              @click="tableEvent(btn, 'xTable2')"
            />
          </template>
          <vxe-grid
            ref="xTable2"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="240"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions1.columns"
            :data="gridOptions1.data"
          >
            <!-- <template #toolbar /> -->
          </vxe-grid>
        </TableCommon>
      </template>
      <template v-if="conditions.templateCode === 'contractChannel'">
        <TableCommon
          title="合同渠道信息"
          :custome-config="() => vxeShowCustom('xTable3')"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
        >
          <template #button>
            <table-button
              v-for="btn in gridOptions2.buttons"
              :key="btn.label"
              :name="btn.icon"
              :tip="btn.label"
              @click="tableEvent(btn, 'xTable3')"
            />
          </template>
          <vxe-grid
            ref="xTable3"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="240"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions2.columns"
            :data="gridOptions2.data"
          >
            <!-- <template #toolbar /> -->
          </vxe-grid>
        </TableCommon>
      </template>
    </div>
  </div>
</template>
<script>
import { apiExportExcelTemplate, apiExcelImport, apiGetExcelImportData } from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { frontExport } from '@/utils/frontExport'
import { apiGetContractNy, apiGetContractChfl, apiContractImport } from '@/api/sap/contract'

export default {
  data() {
    return {
      conditions: {
        templateCode: 'contractBase',
        batchNumber: ''
      },
      selectTypes: [
        {
          id: 'contractBase',
          name: '合同基本信息批导'
        },
        {
          id: 'contractArea',
          name: '合同区域信息批导'
        },
        {
          id: 'contractChannel',
          name: '合同渠道信息批导'
        }
      ],
      loading: false,
      pagination: {
        page: 1,
        pagesize: 5000,
        totalCount: 0
      },
      gridOptions: {
        buttons: [
          {
            label: '导出',
            style: 'primary',
            icon: 'export',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'export',
            source: 'gridOptions',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '基本信息批导',
            style: 'primary',
            icon: 'import',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'import',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '保存',
            style: 'primary',
            icon: 'save',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'save',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ],
        columns: [
          {
            field: 'ICON',
            width: 60,
            title: '状态'
          },
          {
            field: 'CNRTLN',
            title: '合同编号',
            width: 130
          },
          {
            field: 'CNTRNAME',
            title: '合同名称',
            width: 150
          },
          {
            field: 'CUSTOMER',
            title: '客户编号',
            width: 100
          },
          {
            field: 'CHFL',
            title: '存货分类',
            width: 100
          },
          {
            field: 'ADDRESS',
            title: '地址',
            width: 120
          },
          {
            field: 'CONTR_YEAR',
            title: '合同年度',
            width: 80
          },
          {
            field: 'SAL_CENTER',
            title: '营销中心',
            width: 90
          },
          {
            field: 'SIGN_STATUS',
            title: '新签/续签',
            width: 90
          },
          {
            field: 'COTR_QTY',
            title: '合同数量',
            width: 100
          },
          {
            field: 'COTR_AMT',
            title: '合同金额',
            width: 110
          },
          {
            field: 'COTR_START',
            title: '起始日期',
            width: 120
          },
          {
            field: 'CONT_END',
            title: '到期日期',
            width: 120
          },
          {
            field: 'CONT_CLOSE',
            title: '终止日期',
            width: 120
          }
        ],
        data: []
      },
      gridOptionsm: {
        columns: [
          { type: 'seq', title: '序号', filed: 'seq', width: 80 },
          {
            field: 'CHFL',
            title: '存货分类'
          },
          {
            field: 'YEAR_MONTH',
            title: '年月',
            formatter: ({ cellValue }) => cellValue.replace(/^(\d{4})(\d{2})/, `$1-$2`)
          },
          {
            field: 'UNIT',
            title: '单位'
          },
          {
            field: 'QUANTITY',
            title: '件数',
            slots: { default: 'QUANTITY' }
          },
          {
            field: 'AMOUNT',
            title: '计划外数量(件)',
            slots: { default: 'AMOUNT' }
          },
          {
            field: 'QUANTITY_OUTER',
            title: '计划外金额(万元)',
            slots: { default: 'QUANTITY_OUTER' }
          },
          {
            field: 'AMOUNT_OUTER',
            title: '金额(万元)',
            slots: { default: 'AMOUNT_OUTER' }
          },
          {
            field: 'REMARK',
            title: '备注',
            slots: { default: 'REMARK' }
          }
        ],
        data: [],
        columnsFieldTypes: {
          quantity: 'input',
          amount: 'input',
          remark: 'input'
        },
        editConfig: { trigger: 'click', mode: 'cell' }
      },
      gridOptions1: {
        buttons: [
          {
            label: '导出',
            style: 'primary',
            icon: 'export',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'export',
            source: 'gridOptions1',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '区域信息批导',
            style: 'primary',
            icon: 'import',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'import',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '保存',
            style: 'primary',
            icon: 'save',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'save',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ],
        columns: [
          {
            field: 'ICON',
            width: 100,
            title: '状态'
          },
          {
            field: 'CNRTLN',
            width: 150,
            title: '合同编号'
          },
          {
            field: 'REGION',
            title: '经营区域（省）'
          },
          {
            field: 'CITY',
            title: '经营区域（市）'
          },
          {
            field: 'STREET',
            title: '经营区域（县）'
          }
        ],
        data: []
      },
      gridOptions2: {
        buttons: [
          {
            label: '导出',
            style: 'primary',
            icon: 'export',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'export',
            source: 'gridOptions2',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '渠道信息批导',
            style: 'primary',
            icon: 'import',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'import',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '保存',
            style: 'primary',
            icon: 'save',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'save',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ],
        columns: [
          {
            field: 'ICON',
            title: '状态'
          },
          {
            field: 'CNRTLN',
            title: '合同编号'
          },
          {
            field: 'CHANNEL',
            title: '渠道'
          }
        ],
        data: []
      },
      catchImportData: [],
      catchChfl: [],
      contract: {
        month: '',
        year: '',
        cnrtln: '',
        cntrno: ''
      },
      allChfls: []
    }
  },
  computed: {},
  created() {
    this.getContractChfl()
  },
  methods: {
    // 模板下载
    async downloadTemplate({ type, filename }) {
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${filename}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      // link.setAttribute('download', '模板')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    conditionChanged(value) {
      this.pagination = {
        page: 1,
        pagesize: 5000,
        totalCount: 0
      }
    },
    // 处理分页事件
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.handleQueryImportExcel()
    },
    tableEvent(btn, table) {
      switch (btn.code) {
        case 'import':
          this.handleImportExcel(table)
          break
        case 'export':
          frontExport(this[btn.source].columns, this[btn.source].data)
          break
        case 'download':
          switch (this.conditions.templateCode) {
            case 'contractBase':
              this.downloadTemplate('contractBase')
              break
          }
          break
        case '删除':
          this.$refs.xTable.removeCheckboxRow()
          break
        case 'save':
          this.handleSaveImportExcel()
          break
      }
    },
    // 导入excel
    async handleImportExcel(table) {
      this.$refs[table]
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })

          const params = {
            formData,
            templateCode: this.conditions.templateCode
          }
          this.loading = true
          try {
            const res = await apiExcelImport(params)
            if (res?.status === 1) {
              this.conditions.batchNumber = res.data
              this.handleQueryImportExcel(res.data)
            }
          } catch (e) {
          }
          this.loading = false
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.pagination
      const params = { ...this.conditions, page, pagesize }
      try {
        const res = await apiGetExcelImportData(params)
        this.catchImportData = []
        this.catchChfl = []
        // 缓存sap检查之前的数据
        this.catchImportData = res.data.Rows
        for (const item of res.data.Rows) {
          // 转换大小写
          Object.keys(item).forEach(key => {
            item[this.toLineAndUp(key)] = item[key]
            delete item[key]
          })
          // 生成明细并保存进缓存
          if (this.conditions.templateCode === 'contractBase') {
            await this.generateDetail(item)
          }
        }
        this.gridOptionsm.data = []
        this.checkData('X', this.catchImportData)
      } catch (e) {
        this.loading = false
      }
    },
    // 生成存货分类明细
    async generateDetail(baseInfo) {
      // 获取财年对应的年月
      let { GJAHR: year, MONAT: month } = await this.findByYear(baseInfo.CONTR_YEAR)
      month -= 0
      year -= 0
      const { COTR_AMT: amt, COTR_QTY: qty } = baseInfo
      // const subquantity = parseInt((qty - 0) / 12)
      // const remainQuantity = qty - subquantity * 12
      // const subamoney = parseInt((amt - 0) / 12)
      // const remainAmoney = amt - subamoney * 12
      const subquantity = qty / 12
      const subamoney = amt / 12

      const chfl = []

      Array.from({ length: 12 }).forEach((v, i) => {
        const data = {
          CHFL: baseInfo.CHFL,
          YEAR_MONTH: `${year}${month >= 10 ? month : '0' + month}`,
          UNIT: '箱',
          QUANTITY: subquantity,
          AMOUNT: subamoney,
          QUANTITY_OUTER: '',
          AMOUNT_OUTER: ''
        }
        // if (i === 11) {
        //   data.QUANTITY += remainQuantity
        //   data.AMOUNT += remainAmoney
        // }
        month++
        if (month > 12) {
          year += 1
          month = 1
        }
        chfl.unshift(data)
        this.catchChfl.unshift(data)
      })
      baseInfo.FLFY = chfl
    },
    // 转换行里面channel有"/"的数据
    transformChannel(data) {
      const res = []
      data.forEach(item => {
        let channel
        if (item.CHANNEL.indexOf('/') > -1) {
          channel = item.CHANNEL.split('/')
        } else {
          channel = [item.CHANNEL]
        }

        channel.forEach(v => {
          res.push({
            ...item,
            CHANNEL: v
          })
        })
      })
      return res
    },
    // 转换行里面street有"/"的数据
    transformArea(data) {
      const res = []
      data.forEach(item => {
        let street
        if (item.STREET.indexOf('/') > -1) {
          street = item.STREET.split('/')
        } else {
          street = [item.STREET]
        }

        street.forEach(v => {
          res.push({
            ...item,
            STREET: v
          })
        })
      })
      return res
    },
    // 校验数据或保存 check:'X' 为检查否则为保存
    async checkData(check, data) {
      if (!data.length) {
        this.loading = false
        return
      }
      const modeType = {
        contractBase: 'CNTR_HD',
        contractArea: 'CNTR_AR',
        contractChannel: 'CNTR_QD'
      }
      // 如果是渠道
      if (this.conditions.templateCode === 'contractChannel' && check === 'X') {
        data = this.transformChannel(data)
      } else if (this.conditions.templateCode === 'contractArea' && check === 'X') {
        data = this.transformArea(data)
      } else if (this.conditions.templateCode === 'contractBase' && check === 'X') {
        data = data.map(item => {
          const itm = { ...item }
          itm.COTR_START = this.transformDate(item.COTR_START)
          itm.CONT_END = this.transformDate(item.CONT_END)
          itm.CONT_CLOSE = this.transformDate(item.CONT_CLOSE)
          return itm
        })
        console.log(data, 'sjklk')
      }
      const params = {
        check,
        mode: modeType[this.conditions.templateCode],
        user_bp: this.$store.getters.role.USER_BP,
        [modeType[this.conditions.templateCode]]: data
      }
      try {
        const res = await apiContractImport(params)
        if (res.MSGTYPE === 'S') {
          if (check === 'X') {
            if (this.conditions.templateCode === 'contractBase') {
              this.gridOptions.data = res.DATA
              res.DATA.forEach(v => {
                this.gridOptionsm.data.push(...v.FLFY)
              })
            } else if (this.conditions.templateCode === 'contractArea') {
              this.gridOptions1.data = res.DATA
            } else {
              this.gridOptions2.data = res.DATA
            }
          }
          this.$message.success(res.MESSAGE)
        } else {
          this.$message.warning(res.MESSAGE)
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 将导入临时表的数据保存到正式业务表
    async handleSaveImportExcel() {
      this.loading = true
      if (this.conditions.templateCode === 'contractBase') {
        this.checkData('', this.gridOptions.data)
      } else if (this.conditions.templateCode === 'contractArea') {
        this.checkData('', this.gridOptions1.data)
      } else {
        this.checkData('', this.gridOptions2.data)
      }
    },
    transformDate(date) {
      if (date.indexOf('/') > -1) {
        return date.replaceAll('/', '')
      } else if (date.indexOf('-') > -1) {
        return date.replaceAll('-', '')
      } else if (date.indexOf('.') > -1) {
        return date.replaceAll('.', '')
      } else {
        return date
      }
    },
    // 驼峰转成下划线并且大写
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toUpperCase()
    },
    filterChfl(chfl) {
      let str = ''
      try {
        str = this.allChfls.find(v => v.VALUE_ID === chfl).VALUE_KT
      } catch (e) {
        str = chfl
      }
      return str
    },
    async getContractChfl(dictcode) {
      const { DATA } = await apiGetContractChfl()
      this.allChfls = DATA
    },
    // 获取财年时间
    async findByYear(gjahr) {
      const { DATA } = await apiGetContractNy({ gjahr })
      return DATA
    }
  }
}
</script>

<style lang="scss" scoped>
.download {
  text-align: right;
  line-height: 36px;
  font-size: 14px;
  .tempDownload {
    display: flex;
    align-items: center;
    img {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
    span {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contract-manage/contractImport.vue